import React, {useContext} from 'react'
import { Navigate, useNavigate } from 'react-router-dom'
import LoginContext from '../../../context/login_context/LoginContext';

export const ProtectedRoute = ({children}) => {
  const {LoginState,SetLogin,CloseLogin,GetLoginSession} = useContext(LoginContext);
  
  const navigate = useNavigate()

  if(LoginState.user==="NO-USER"){
    return <Navigate to={'/'} replace={true}/>
  }
  return children ? children : <Navigate to={'/'} replace={true}/>
}
